import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/header';
import classes from './App.css';
import Footer from './components/footer';

function App() {

  return (
    <div>
      <Header />
      <Footer />
    </div>
  );
}

export default App;